module.exports = __webpack_public_path__ + "static/media/About Us Picture 02.212b2236.jpg";